import React, { useMemo } from 'react';

import Button from '../../../common/Button/Button';
import CaretDownIcon from '../../../common/icons/CaretDownIcon';
import CaretUpIcon from '../../../common/icons/CaretUpIcon';
import Label from '../../../common/Labels/Label';

import { getLabelForEdgeLocations } from '../../edge_utils';

const Caret = ({ open }) => open ? <CaretUpIcon fill="brand" /> : <CaretDownIcon fill="brand" />;

export const getDropdownLabelForEdgeLocations = (locations = [], totalNumberOfEdges = 0) => {
  if (!locations?.length) {
    return 'Filter Edges';
  }
  return getLabelForEdgeLocations(locations, totalNumberOfEdges);
}

export const EdgeLocationDropdownButton = ({ 
  locations = [], totalNumberOfEdges = 0, onClick = () => {}, open = false, hideCaret = false,
}) => {
  const dropdownLabel = useMemo(() => getDropdownLabelForEdgeLocations(locations, totalNumberOfEdges), [locations, totalNumberOfEdges]);
  return (
    <Button onClick={onClick}>
      <div className="flex justify-between items-center">
        <Label className="mr-2" size="lg">{ dropdownLabel }</Label>
        {
          !hideCaret && (
            <Caret open={open} />
          )
        }
      </div>
    </Button>
  )
}

export default EdgeLocationDropdownButton;
